<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="4" v-for="(v,k) in listCoberturas" :key="k">
                    <div class="text-center">
                        <v-tooltip top color="secondary" max-width="30%">
                            <template v-slot:activator="{ on }">
                                <v-img :src="v.base64" contain height="100" max-height="100" v-on="on"></v-img>
                            </template>
                            <p v-html="v.definicionCorta"></p>
                        </v-tooltip>
                        <span class="body-2 font-weight-bold" v-html="v.cobertura"></span>
                        <p class="caption font-weight-bold" v-html="v.valorCobertura"></p>
                    </div>
                </v-col>
            </v-row>
            
            <v-row dense>
                <v-col cols="12" sm="12">
                    <div class="text-right">
                        <v-btn class="body-2 font-weight-bold ma-2" outlined color="secondary">Prima Total $ {{ obBusqueda.prima_valor_neto }}</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-row dense class="mt-3 mb-3" align="center" justify="center">
                <v-col cols="12" class="text-center">
                    <v-icon color="secundary" class="btnNext" @click="setStep(4)">arrow_forward</v-icon>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformacionCoberturaComponent',
        inject:['setData','setStep'],
        props:{
            active:{
                type:Boolean,
                default:false
            },
            listCoberturas:{
                type:Array,
                default: () => []
            },
            parametros:{
                type:Object,
                default:{}
            },
            obBusqueda:{
                type:Object,
                default:{}
            }
        },
        created(){
            this.onListarCoberturas();
        },
        watch:{
            active(val){
                if(val && _.size(this.listCoberturas) == 0){
                    this.onListarCoberturas();
                }
            }
        },
        methods:{
            onListarCoberturas(){
                var error = 'E';
                var o = _.merge({opcion:'LISTAR_COBERTURAS_CERTIFICADO',idEstado:_.get(this.parametros,'id_estado_default')},
                                _.pick(this.obBusqueda,['idCertificado','idPoliza'])
                               );

                axios.post(`${BASE_URI}administrador/cobertura/listar`,o)
                     .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                            var l = _.cloneDeep(r.data.data);
                            l = _.map(l,(v)=>{
                                v.valorCobertura = `$ ${v.valorCobertura}`;
                                return v;
                            });

                            this.setData('listGeneral.listCoberturas',l);
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     })
            }
        }
    }
</script>